<a href="#main" className="sr-only focus:sr-restore">Skip to main content</a>
import { Routes, Route } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import GoogleAnalytics from '@/components/GoogleAnalytics';
import { PromotionalProvider } from '@/contexts/PromotionalContext';
import '@/utils/analytics-debug'; // Import debug utilities
import HomePage from '@/pages/HomePage';
import CoursesPage from '@/pages/CoursesPage';
import CourseBundlesPage from '@/pages/CourseBundlesPage';
import AutomationPage from '@/pages/AutomationPage';
import CourseDetailPage from '@/pages/CourseDetailPage';
import BundleDetailPage from '@/pages/BundleDetailPage';
import PathsPage from '@/pages/PathsPage';
import SeleniumCSharpPathPage from '@/pages/SeleniumCSharpPathPage';
import PlaywrightPathPage from '@/pages/PlaywrightPathPage';
import SeleniumJavaPathPage from '@/pages/SeleniumJavaPathPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import HelpPage from '@/pages/HelpPage';
import PrivacyPage from '@/pages/PrivacyPage';
import RefundPage from '@/pages/RefundPage';
import TermsPage from '@/pages/TermsPage';
import ResourcesPage from '@/pages/ResourcesPage';
import NotFoundPage from '@/pages/NotFoundPage';

function App() {
  // Add debugging
  console.log('App component loaded');
  
  return (
    <PromotionalProvider>
      <GoogleAnalytics trackingId="G-JD04142MD7" />
      <Routes>
      {/* Routes that need the full layout */}
      <Route path="/" element={<Layout><HomePage /></Layout>} />
      <Route path="/courses" element={<Layout><CoursesPage /></Layout>} />
      <Route path="/course-bundles" element={<Layout><CourseBundlesPage /></Layout>} />
      <Route path="/automation" element={<Layout><AutomationPage /></Layout>} />
      <Route path="/courses/:id" element={<Layout><CourseDetailPage /></Layout>} />
      <Route path="/bundle/:bundleId" element={<Layout><BundleDetailPage /></Layout>} />
      <Route path="/paths" element={<Layout><PathsPage /></Layout>} />
      <Route path="/paths/selenium-csharp" element={<Layout><SeleniumCSharpPathPage /></Layout>} />
      <Route path="/paths/playwright" element={<Layout><PlaywrightPathPage /></Layout>} />
      <Route path="/paths/selenium-java" element={<Layout><SeleniumJavaPathPage /></Layout>} />
      <Route path="/about" element={<Layout><AboutPage /></Layout>} />
      <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
      <Route path="/help" element={<Layout><HelpPage /></Layout>} />
      <Route path="/privacy" element={<Layout><PrivacyPage /></Layout>} />
      <Route path="/refund" element={<Layout><RefundPage /></Layout>} />
      <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
      <Route path="/resources" element={<Layout><ResourcesPage /></Layout>} />
      
      {/* 404 page */}
      <Route path="*" element={<Layout><NotFoundPage /></Layout>} />
      </Routes>
    </PromotionalProvider>
  );
}

export default App;